import { useEffect, useRef, useState } from "react";
import {
  Box,
  Paper,
  TextField,
  IconButton,
  Typography,
  Fab,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

export default function ChatComponent() {
  const reduxMessages = useSelector((state) => state.websocket.messages);
  const [input, setInput] = useState("");
  const [showScrollBtn, setShowScrollBtn] = useState(false);
  const [users, setUsers] = useState([]);

  /* const array = reduxMessages.map((el) => JSON.parse(el));
  const userList = array.filter((el) => el.type === "welcome");
  const userId = userList[0].userId;

  console.log(reduxMessages); */

  const scrollRef = useRef(null);
  const dispatch = useDispatch();

  //Filtrare per i messaggi con type private message
  /* 
  useEffect(() => {
    const array = reduxMessages.map((el) => JSON.parse(el));
    const userList = array.filter((el) => el.type === "userList");
    const lastUserList = userList[userList.length - 1];
    setUsers(lastUserList.users);
  }, [reduxMessages]); */

  console.log(users);

  const handleSend = () => {
    if (!input.trim()) return;

    const msg = {
      type: "privateMessage",
      text: input,
      to: users[0].userId,
    };
    dispatch({
      type: "websocket/send",
      payload: msg,
    });

    setInput("");
  };

  const scrollToBottom = () => {
    scrollRef.current?.scrollTo({
      top: scrollRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToBottom();
  }, [reduxMessages]);

  const handleScroll = () => {
    if (!scrollRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
    setShowScrollBtn(!isAtBottom);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        width: "100%",
        height: 500,
        display: "flex",
        flexDirection: "column",
        p: 2,
        position: "relative",
      }}
    >
      {/* Chat History */}
      <Box
        ref={scrollRef}
        onScroll={handleScroll}
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mb: 1,
          pb: 6,
        }}
      >
        {reduxMessages.map((msg, index) => {
          const message = JSON.parse(msg);
          /* if (message.type === "welcome" || message.type === "userList") {
            return;
          } */
          return (
            <Box
              key={index}
              sx={{
                alignSelf: message.self ? "flex-end" : "flex-start",
                bgcolor: message.self ? "primary.main" : "grey.300",
                color: message.self ? "#fff" : "#000",
                border: message.type === "system" ? "1px solid red" : "",
                px: 2,
                py: 1,
                borderRadius: 2,
                maxWidth: "75%",
                minWidth: "50%",
              }}
            >
              <Box display="flex" justifyContent="space-between">
                <Typography variant="caption">{message.sender}</Typography>
                <Typography variant="caption">{msg.sendTime}</Typography>
              </Box>
              <Box
                sx={{
                  bgcolor: message.self ? "primary.main" : "grey.300",
                  color: message.self ? "#fff" : "#000",
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  mt: 0.3,
                }}
              >
                <Typography variant="body2">
                  {message.text || message.message}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>

      {/* Scroll to bottom button */}
      {showScrollBtn && (
        <Fab
          size="small"
          color="primary"
          onClick={scrollToBottom}
          sx={{
            position: "absolute",
            bottom: 70,
            left: "calc(100% / 2)",
            border: "1px solid white",
          }}
        >
          <ArrowDownwardIcon />
        </Fab>
      )}

      {/* Input Area */}
      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Type a message"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />
        <IconButton color="primary" onClick={handleSend}>
          <SendIcon />
        </IconButton>
      </Box>
    </Paper>
  );
}
